import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { Button, ButtonType } from "@/components/common/button";
import { InputField } from "@/components/common/input";
import { useState } from "react";
import dayjs from "dayjs";

const CustomDate = ({
  question,
  questionValue,
  setQuestionValue,
  setQuestionAnswer,
}: QuizQuestionProps<string>) => {
  const [error, setError] = useState("");

  const isFormAnswered = questionValue.length === 10; // mm/dd/yyyy

  const onSubmit = async () => {
    if (isFormAnswered) {
      const date = dayjs(questionValue, "MM/DD/YYYY", true);
      const today = dayjs().endOf("day");
      const isValid = date.isValid();

      if (!isValid) {
        setError("Please enter valid date in MM/DD/YYYY format.");
        return;
      }

      if (question?.attributes?.disableFuture && date.isAfter(today)) {
        setError("Future dates are not allowed.");
        return;
      }

      setQuestionAnswer(questionValue);
    } else {
      setError("Incorrect date format");
    }
  };

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuestionValue(e.target.value);
    setError("");
  };

  return (
    <>
      <InputField
        value={questionValue}
        name="date"
        onChange={onInputChange}
        label={(question?.attributes?.placeholder as string) ?? ""}
        type="date"
        placeholder="MM/DD/YYYY"
        error={error}
      />

      <Button
        type={ButtonType.CONTINUE}
        disabled={!isFormAnswered || !!error}
        onClick={onSubmit}
      />
    </>
  );
};

export { CustomDate };
